export const BAFTA_IMPACT_FUND_SLUG = 'bafta-albert';

export const BASKET_MAX_LINE_ITEMS = 50;

export const UK_CLIMATE_AND_NATURE_FUND_TITLE = 'UK Nature Fund';

export const ANONYMOUS_CHECKOUT_ACCOUNT_NOTICE =
  "We'll automatically set you up with an Ecologi account. This opts you into marketing emails. Manage your preferences anytime.";
